import React from 'react';
import { Link } from 'react-router-dom';
import { Construction } from 'lucide-react';

/**
 * Shown for unfinished / mock-only modules that remain in the codebase
 * but must not present fake operational UI to customers.
 */
export const ModuleUnderDevelopment: React.FC<{
  title: string;
  description?: string;
  backTo?: string;
}> = ({
  title,
  description = 'This module is under development and is not yet available for production use.',
  backTo = '/demo',
}) => (
  <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-16 text-center">
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-700">
      <Construction className="h-7 w-7" aria-hidden />
    </div>
    <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
    <p className="mt-2 text-sm text-slate-600">{description}</p>
    <p className="mt-4 text-xs text-slate-500">
      Implementation is preserved for future release. No simulated transactions are available here.
    </p>
    <Link
      to={backTo}
      className="mt-8 inline-flex rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
    >
      Back
    </Link>
  </div>
);

export default ModuleUnderDevelopment;
